<script setup lang="ts">
const { data } = await useAsyncData('privacy-policy', () =>
  queryCollection('docs').path('/docs/privacy').first()
)

useDefaultMeta({
  title: 'Kebijakan Privasi',
  description:
    'Kebijakan Privasi ini bertujuan membantu Anda memahami informasi yang kami kumpulkan serta cara memperbarui, mengelola, mengekspor &amp; menghapus informasi Anda'
})

useHead({
  htmlAttrs: {
    class: 'scroll-smooth'
  }
})
</script>
<template>
  <section class="py-16">
    <UiContainer>
      <UiSectionTitle
        class="lg:text-center mb-7 lg:mb-10"
        title-as="h1"
        title="Kebijakan Privasi"
      />
      <div class="grid lg:grid-cols-3 lg:w-9/12 gap-5 lg:mx-auto">
        <div class="lg:order-2">
          <UiToc :links="data?.body?.toc?.links" />
        </div>
        <div class="lg:col-span-2 lg:order-1">
          <div class="prose dark:prose-invert max-w-none">
            <ContentRenderer v-if="data" :value="data" />
          </div>
        </div>
      </div>
    </UiContainer>
  </section>
</template>
